export function parseSetupAmount (value) {
  if (value === null || value === undefined || String(value).trim() === '') return NaN
  const text = String(value).trim()
  const amount = Number(text.includes(',') ? text.replace(/\./g, '').replace(',', '.') : text)
  return Number.isFinite(amount) ? amount : NaN
}

export function setupMinimumError (plan, propertyType, setup) {
  const field = propertyType === 'Residencial' ? 'gplValorMinSetupResidencial'
    : propertyType === 'Comercial' ? 'gplValorMinSetupComercial' : null
  if (!field) return 'Informe se o imóvel é Residencial ou Comercial para validar o Setup.'
  const minimum = parseSetupAmount(plan?.[field])
  if (!Number.isFinite(minimum) || minimum < 0) return `Configure o Valor Mínimo Setup ${propertyType} no plano da garantidora.`
  const amount = parseSetupAmount(setup)
  if (!Number.isFinite(amount) || amount < 0) return 'Informe um valor de Setup válido, maior ou igual a zero.'
  if (amount < minimum) return `O Setup ${propertyType} deve ser de pelo menos ${minimum.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}.`
  return ''
}
